// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2gCi8","range":"MonthRangeSwitch_range__285jt","disabled":"MonthRangeSwitch_disabled__314_2"};